var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 70,
    viewBox: "0 0 64 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3557 1.78571C29.4672 -0.595233 34.5328 -0.595239 38.6443 1.78571L57.3557 12.6214C61.467 15.0023 64 19.4025 64 24.1644V45.8357C64 50.5975 61.467 54.9976 57.3557 57.3788L38.6443 68.2145C34.5328 70.5951 29.4672 70.5951 25.3557 68.2145L6.6443 57.3788C2.53279 54.9976 0 50.5975 0 45.8357V24.1644C0 19.4025 2.53279 15.0023 6.6443 12.6214L25.3557 1.78571Z",
    fill: "#FFB43A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 28C32.879 28.0024 30.8456 28.846 29.3458 30.3458C27.846 31.8456 27.0024 33.879 27 36C27 39.255 29.363 41.958 31.866 44.819C32.658 45.725 33.478 46.662 34.208 47.61C34.3014 47.7312 34.4214 47.8293 34.5587 47.8968C34.696 47.9644 34.847 47.9995 35 47.9995C35.153 47.9995 35.304 47.9644 35.4413 47.8968C35.5786 47.8293 35.6986 47.7312 35.792 47.61C36.522 46.662 37.342 45.725 38.134 44.819C40.637 41.958 43 39.255 43 36C42.9976 33.879 42.154 31.8456 40.6542 30.3458C39.1544 28.846 37.121 28.0024 35 28V28ZM35 39C34.4067 39 33.8266 38.8241 33.3333 38.4944C32.8399 38.1648 32.4554 37.6962 32.2284 37.148C32.0013 36.5999 31.9419 35.9967 32.0576 35.4147C32.1734 34.8328 32.4591 34.2982 32.8787 33.8787C33.2982 33.4591 33.8328 33.1734 34.4147 33.0576C34.9967 32.9419 35.5999 33.0013 36.1481 33.2284C36.6962 33.4554 37.1648 33.8399 37.4944 34.3333C37.8241 34.8266 38 35.4067 38 36C38 36.7956 37.6839 37.5587 37.1213 38.1213C36.5587 38.6839 35.7956 39 35 39Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22.5C29.3487 22.503 26.8069 23.5575 24.9322 25.4322C23.0575 27.3069 22.003 29.8487 22 32.5C22 36.5687 24.9538 39.9475 28.0825 43.5237C29.0725 44.6562 30.0975 45.8275 31.01 47.0125C31.1268 47.164 31.2767 47.2866 31.4484 47.3711C31.62 47.4555 31.8087 47.4993 32 47.4993C32.1913 47.4993 32.38 47.4555 32.5516 47.3711C32.7233 47.2866 32.8732 47.164 32.99 47.0125C33.9025 45.8275 34.9275 44.6562 35.9175 43.5237C39.0462 39.9475 42 36.5687 42 32.5C41.997 29.8487 40.9425 27.3069 39.0678 25.4322C37.1931 23.5575 34.6513 22.503 32 22.5V22.5ZM32 36.25C31.2583 36.25 30.5333 36.0301 29.9166 35.618C29.2999 35.206 28.8193 34.6203 28.5355 33.9351C28.2516 33.2498 28.1774 32.4958 28.3221 31.7684C28.4667 31.041 28.8239 30.3728 29.3483 29.8483C29.8728 29.3239 30.541 28.9667 31.2684 28.8221C31.9958 28.6774 32.7498 28.7516 33.4351 29.0355C34.1203 29.3193 34.706 29.7999 35.118 30.4166C35.5301 31.0333 35.75 31.7583 35.75 32.5C35.75 33.4946 35.3549 34.4484 34.6517 35.1516C33.9484 35.8549 32.9946 36.25 32 36.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_18",
    x: 9,
    y: 12,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_18"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.13668432ef4c67ae75b829e17576e077.svg";
export { ForwardRef as ReactComponent };